import { AxiosError } from 'axios';
import { FormikActions } from 'formik';

export const handleError = (error: AxiosError) => {
  console.log(error);
};

export const createTestFormikActions = (): FormikActions<any> => {
  return {
    setStatus: jest.fn(),
    setErrors: jest.fn(),
    setError: jest.fn(),
    setSubmitting: jest.fn(),
    setTouched: jest.fn(),
    setValues: jest.fn(),
    setFieldValue: jest.fn(),
    setFieldError: jest.fn(),
    setFieldTouched: jest.fn(),
    validateField: jest.fn(),
    validateForm: jest.fn(),
    resetForm: jest.fn(),
    submitForm: jest.fn(),
    setFormikState: jest.fn()
  };
};



// WEBPACK FOOTER //
// ./src/modules/utils.ts